import React, {useState, useEffect, useCallback} from 'react'
import {api} from './api'
import {fmt} from './lib'

export default function Foods() {
  const [foods, setFoods] = useState([])
  const [q, setQ] = useState('')
  const [err, setErr] = useState('')

  const load = useCallback(async query => {
    try {
      const {foods} = await api.foods(query)
      setFoods(foods)
    } catch (e) {
      setErr(e.message)
    }
  }, [])

  useEffect(() => {
    const t = setTimeout(() => load(q.trim()), 150)
    return () => clearTimeout(t)
  }, [q, load])

  const remove = async fid => {
    try {
      await api.delFood(fid)
      load(q.trim())
    } catch (e) {
      setErr(e.message)
    }
  }

  return (
    <div className="page">
      <header className="page-head">
        <h1>Foods</h1>
        <span className="page-sub">your saved library</span>
      </header>

      <input className="input" placeholder="Search foods…" value={q} onChange={e => setQ(e.target.value)} />

      {foods.length === 0 && (
        <div className="empty">
          {q ? 'No matches.' : 'No saved foods yet.'}
          <br />
          Anything you log gets saved here for quick re-adding.
        </div>
      )}

      <div className="list">
        {foods.map(f => (
          <div key={f.fid} className="entry entry-static">
            <div className="entry-main">
              <div className="entry-name">{f.name}</div>
              <div className="entry-macros">
                {f.protein ? <span style={{color: 'var(--protein)'}}>P {f.protein}</span> : null}
                {f.carbs ? <span style={{color: 'var(--carbs)'}}>C {f.carbs}</span> : null}
                {f.fat ? <span style={{color: 'var(--fat)'}}>F {f.fat}</span> : null}
                <span className="entry-qty">used {f.count}×</span>
              </div>
            </div>
            <div className="entry-cal">{fmt(f.calories)}</div>
            <span className="entry-del" onClick={() => remove(f.fid)} aria-label="delete">
              ✕
            </span>
          </div>
        ))}
      </div>

      {err && (
        <div className="toast" onClick={() => setErr('')}>
          {err}
        </div>
      )}
    </div>
  )
}
